import BaseDTO from '../base/BaseDTO';

export default class Detail extends BaseDTO {

    public name: string | undefined;
    public isNamingRelevant: boolean;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.name = data['name'] || undefined;
        this.isNamingRelevant = data['isNamingRelevant'] || false;
    }

}